import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentCompleted = _resolveComponent("PaymentCompleted")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createBlock(_component_PaymentCompleted, {
        key: 0,
        "payment-id": "",
        "payment-success-redirect": true
      }))
    : _createCommentVNode("", true)
}